<h1 class="title">General Preferences/Settings</h1>
<h5>Manage organisation preferences and settings</h5>

<acabim-card
        class="push-up-2"
        [cardContent]="banner"
        [isCollapsible]="true"
        [isCollapsed]="false"
        [hasHelpButton]="true"
        helpMessage="Tick to enable branding banner. Add a colour for the banner background."
        cardHeading="Branding banner details">
</acabim-card>

<acabim-card
        class="push-up-2"
        [cardContent]="settings"
        [isCollapsible]="true"
        [isCollapsed]="false"
        [hasHelpButton]="true"
        helpMessage="Tick to enable automated background processes. Untick to disable them."
        cardHeading="ON/OFF Switches for Automated Processes">
</acabim-card>

<ng-template #settings>
    <p-toast key="organisationPreferences" position="top-center" life="3000"></p-toast>
    <ng-container *ngIf="!isLoading else showLoading">
        <form [formGroup]="preferencesForm" class="cas-flex-column cas-form-floating">
            <acabim-form-block labelWidth="14" [labelAlign]="'right'" [colonize]="true" class="push-up-2">
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Auto-execute maintenance actions</acabim-form-input-label>
                    <acabim-form-input-content [mediumField]="true">
                        <p-checkbox formControlName="runActionTasks" [binary]="true"></p-checkbox>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Auto-generate building assets</acabim-form-input-label>
                    <acabim-form-input-content [mediumField]="true">
                        <p-checkbox formControlName="runGenerateAssetsTask" [binary]="true"></p-checkbox>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Auto-generate LTM Items</acabim-form-input-label>
                    <acabim-form-input-content [mediumField]="true">
                        <p-checkbox formControlName="runImportProjectLtmsTask" [binary]="true"></p-checkbox>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </acabim-form-block>
        </form>
    </ng-container>
</ng-template>

<ng-template #banner>
    <ng-container *ngIf="!isLoading else showLoading">
        <form [formGroup]="preferencesForm" class="cas-flex-column cas-form-floating">
            <acabim-form-block labelWidth="14" [labelAlign]="'right'" [colonize]="true" class="push-up-2">
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Enable branding banner</acabim-form-input-label>
                    <acabim-form-input-content [mediumField]="true">
                        <p-checkbox formControlName="brandingBanner" [binary]="true"></p-checkbox>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Background colour</acabim-form-input-label>
                    <acabim-form-input-content [shortField]="true">
                        <div>
                            <input formControlName="brandingBannerColour" />
                            <button (click)="updateBrandingBackgroundColour()">Update</button>
                        </div>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Text colour</acabim-form-input-label>
                    <acabim-form-input-content [shortField]="true">
                        <div>
                            <input formControlName="brandingTextColour" />
                            <button (click)="updateBrandingTextColour()">Update</button>
                        </div>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </acabim-form-block>
        </form>
    </ng-container>
</ng-template>

<ng-template #showLoading>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
